import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../contexts/authContext';
import { SharingApiError, sharingApi } from '../../lib/api/sharingApi';
export default function SharedLinkPage() {
    const { token } = useParams();
    const navigate = useNavigate();
    const { user } = useAuth();
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const resolveToken = useCallback(async ()=>{
        if (!token) return;
        setIsLoading(true);
        try {
            const result = await sharingApi.resolveToken(token);
            navigate(`/assistant/${result.chatId}?shared=true`, {
                replace: true
            });
        } catch (err) {
            if (err instanceof SharingApiError) {
                setError(err.message);
            } else {
                setError('Something went wrong');
            }
            setIsLoading(false);
        }
    }, [
        token,
        navigate
    ]);
    useEffect(()=>{
        if (!token) return;
        if (!user) {
            // Redirect to login, preserve return URL
            navigate(`/login?returnTo=${encodeURIComponent(`/shared/${token}`)}`, {
                replace: true
            });
            return;
        }
        resolveToken();
    }, [
        token,
        user,
        navigate,
        resolveToken
    ]);
    if (isLoading) {
        return /*#__PURE__*/ _jsx("div", {
            className: "flex items-center justify-center h-screen",
            children: /*#__PURE__*/ _jsx("div", {
                className: "text-center",
                children: /*#__PURE__*/ _jsx("p", {
                    className: "text-muted-foreground",
                    children: "Loading shared chat..."
                })
            })
        });
    }
    if (error) {
        return /*#__PURE__*/ _jsx("div", {
            className: "flex items-center justify-center h-screen",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "text-center max-w-md",
                children: [
                    /*#__PURE__*/ _jsx("h1", {
                        className: "text-2xl font-bold mb-2",
                        children: "Cannot access chat"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-muted-foreground mb-4",
                        children: error
                    }),
                    /*#__PURE__*/ _jsx("a", {
                        href: "/",
                        className: "text-primary hover:underline",
                        children: "Go to home"
                    })
                ]
            })
        });
    }
    return null;
}
